import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-users')({
  beforeLoad: () => getTitleContextSlice('All Users'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
